import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { changeDateToMomentFormat } from "../../../helpers/dateHelpers";
import styles from "./styles.less";

const Dates = ({
  className,
  titles,
  checkin,
  checkout,
  onNewSearchClick,
  isMobileView
}) => {
  const calculateNights = () => {
    let result = "";

    if (checkin && checkout) {
      const ciMoment = changeDateToMomentFormat(checkin, ".");
      const coMoment = changeDateToMomentFormat(checkout, ".");
      result = coMoment.diff(ciMoment, "days");
    }

    return result;
  };

  const onSearchClick = () => {
    const data = {
      payload: {
        newCheckInDate: checkin,
        newCheckOutDate: checkout
      }
    };
    onNewSearchClick(data);
  };

  return (
    <div
      className={cx(styles.dates, className, {
        [styles.mobileView]: isMobileView
      })}
    >
      <div className={styles.checkin}>
        <div className={styles.title}>{titles.CartCheckIn}:</div>
        <div className={styles.value}>{checkin}</div>
      </div>
      <div className={styles.checkout}>
        <div className={styles.title}>{titles.CartCheckOut}:</div>
        <div className={styles.value}>{checkout}</div>
      </div>
      <div className={styles.nightsAndNewSearch}>
        <div className={styles.nights}>
          <div className={styles.title}>{titles.CartNights}:</div>
          <div className={styles.value}>{calculateNights()}</div>
        </div>
        <div
          className={styles.newSearchBtn}
          role="button"
          onClick={onSearchClick}
          onKeyDown={onSearchClick}
          tabIndex="0"
        >
          {titles.NewSearch}
        </div>
      </div>
    </div>
  );
};

Dates.defaultProps = {
  titles: {}
};

Dates.propTypes = {
  titles: PropTypes.object,
  checkin: PropTypes.string,
  checkout: PropTypes.string,
  className: PropTypes.string,
  onNewSearchClick: PropTypes.func,
  isMobileView: PropTypes.bool
};

export default Dates;



// WEBPACK FOOTER //
// ./src/components/Cart/Dates/Dates.js